import { useEffect, useState } from 'react';
import { B2B_ACCOUNT_PROFILE_PATH, B2B_LOGIN_BUSINESS_ACCOUNT_START_PATH, } from '../../constants/paths';
import { apiB2B, apiBase } from '../axios-client';
import { linkedAccountRedirectAnalytics } from '../../utils/linked-accounts/analytics';
import { clearSessionStorageRVData, redirectToB2BHomePage, } from '../../utils/http-helper';
export var getTrails = function (_a) {
    var customerSVOCId = _a.customerSVOCId, _b = _a.host, host = _b === void 0 ? '' : _b;
    if (!customerSVOCId) {
        return Promise.reject(new Error('Cannot call trials without custId'));
    }
    return apiB2B.get("".concat(host, "/b2b/user/account/customer/").concat(customerSVOCId, "/features"));
};
export var getEnrollments = function (_a) {
    var customerUserId = _a.customerUserId, customerSVOCId = _a.customerSVOCId, jwt = _a.jwt, _b = _a.host, host = _b === void 0 ? '' : _b;
    if (!customerSVOCId || !customerUserId || !jwt) {
        return Promise.reject(new Error('Cannot call enrollments without custId or userId or jwt'));
    }
    return apiB2B.get("".concat(host, "/b2b/user/account/").concat(customerUserId, "/customer/").concat(customerSVOCId, "/perks/enrollments"), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Cookie: "THD_CUSTOMER=".concat(jwt),
        },
    });
};
export var getUserState = function (_a) {
    var customerUserId = _a.customerUserId, jwt = _a.jwt, _b = _a.host, host = _b === void 0 ? '' : _b;
    if (!jwt || !customerUserId) {
        return Promise.reject(new Error('Cannot call statemanagement without jwt or custId'));
    }
    return apiB2B.get("".concat(host, "/state/v1/user/").concat(customerUserId), {
        headers: {
            Accept: 'application/json',
            Authorization: "Bearer ".concat(jwt),
        },
    });
};
export var getPolicy = function (_a) {
    var customerSVOCId = _a.customerSVOCId, customerUserId = _a.customerUserId, _b = _a.host, host = _b === void 0 ? '' : _b;
    if (!customerSVOCId || !customerUserId) {
        return Promise.reject(new Error('Cannot call policy without custId or userId'));
    }
    return apiB2B.get("".concat(host, "/b2b/user/account/").concat(customerUserId, "/customer/").concat(customerSVOCId, "/policy"));
};
export var GetProfileDetails = function () {
    var _a = useState(null), profileData = _a[0], setProfileData = _a[1];
    var _b = useState(null), profileError = _b[0], setProfileError = _b[1];
    var _c = useState(false), profileLoaded = _c[0], setProfileLoaded = _c[1];
    useEffect(function () {
        apiBase
            .get(B2B_ACCOUNT_PROFILE_PATH)
            .then(function (response) {
            return setProfileData(response.data);
        })
            .catch(function (error) { return setProfileError(error); })
            .finally(function () { return setProfileLoaded(true); });
    }, []);
    return { profileData: profileData, profileError: profileError, profileLoaded: profileLoaded };
};
export var LoginToBusinessAccount = function (requestData, selectedSvocId) {
    var url = "".concat(B2B_LOGIN_BUSINESS_ACCOUNT_START_PATH, "/").concat(selectedSvocId, "/selectUserCustomer");
    apiB2B.post(url, requestData).then(function () {
        linkedAccountRedirectAnalytics(true);
        clearSessionStorageRVData();
        redirectToB2BHomePage();
    });
};
